import { useMutation, useQuery } from "react-query";
import * as user from "services/user/user";

export const useUserList = () => {
  return useMutation((formData) => user.getUserList(formData));
};

export const useAddUser = () => {
  return useMutation((formData) => user.addUser(formData));
};

export const useEditUser = () => {
  return useMutation((formData) => user.editUser(formData));
};

export const useDeleteUser = () => {
  return useMutation((formData) => user.deleteUser(formData));
};
export const useStatusUser = () => {
    return useMutation((formData) => user.statusUser(formData));
  };
export const useAllRoles = () => {
  return useQuery("getRoles", () => user.getAllRoles(), {
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
  });
};
